export enum PoolScalings {
    Autoscale = 'Autoscale',
    Override = 'Override',
    SizingRatio = 'sizingRatio',
    UnassignedHost = 'UnassignedHost'
}
